import React, { useState, useEffect, useRef, useContext } from "react";
import "../assets/stylesheets/EditorHeader.css";
import docIcon from "../assets/images/doc-icon.png";
import { Link } from "react-router-dom";
import { menuItems } from "../configs/menuItems";
import { MenuItem } from "./MenuItem";

import { stateContext } from "./Context";

export const EditorHeader = () => {
  let {
    docTitle,
    setDocTitle,
    lastModified,
  } = useContext(stateContext);

  // Enter Name of Document
  const nameEntered = (e) => {
    e.which === 13 ? e.target.blur() : e.target.focus();
  };

  return (
    <div className="editor-header">
      <div style={{ display: "flex", alignItems: "center" }}>
        <Link to="/">
          <img src={docIcon} alt="doc icon" className="doc-icon" />
        </Link>
        <div className="action-container">
          <div>
            <p
              contentEditable={true}
              onKeyDown={nameEntered}
              onBlur={(e) => setDocTitle(e.target.innerText)}
              className="doc-name"
              suppressContentEditableWarning={true}
            >
              {docTitle}
            </p>
            {
              lastModified && <p className="last-modified">Last Edit: {lastModified.slice(0,10)}</p>
            }
          </div>
          <nav>
            <ul className="menus">
              {menuItems.map((menu, index) => {
                const depthLevel = 0;
                return (
                  <MenuItem
                    items={menu}
                    key={index}
                    depthLevel={depthLevel}
                    // downloadAsWord={downloadAsWord}
                    // downloadTxtFile={downloadTxtFile}
                  />
                );
              })}
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};
